import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { getBranches } from "../../../../../MyApi/sb/branches";

import SingleBranch from "../singlebranch";
import LoadingSpinner from "../../../../UI/spinner";
import PagnationComponent from "../../../../UI/pagnationComponent";
import ErrorMessage from "../../../../UI/error";
import NoData from "../../../../UI/nodata";

const BranchesDataTable = () => {
  const [filterText, setFilterText] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const { data, isLoading, refetch ,error } = useQuery(
    ["getBranches", currentPage],
    () => getBranches(currentPage)
  );
  const { t } = useTranslation();

  useEffect(() => {
    refetch();
  }, [refetch, filterText, currentPage]);
  const handleSearchChange = (e) => {
    setFilterText(e.target.value);
  };
  const totalItems = data?.total;
  const itemsPerPage = data?.last_page;
  const branches = data?.data || []; 
  const responeMessage = data?.message


   if(isLoading){
      return <LoadingSpinner/>
  }
  if(error){  
    return <ErrorMessage error={error}/>
  }
  if(branches.length === 0){
    return<NoData responeMessage={responeMessage}/>
  }
 
  if(!data){
      return <div>no data available</div>
  }

  const filterdData = branches.filter((branch) =>
    branch.name.toString().toLowerCase().includes(filterText)
  );
  return (
    <div className='container-fluid'>
      <div className="card">
      <div className='table-responsive'>
        <table className="table-responsive-sm table table-hover table-striped">
          <thead>
            <th>#</th>
            <th>{t("Active")}</th>
            <th>{t("Actions")}</th>
           
          </thead>
          <tbody>
            {filterdData.map((branch) => (
              <SingleBranch
                key={branch.id}
                branch={branch}
                refetch={refetch}
              />
            ))}
          </tbody>
        </table>
      </div>
      </div>
      <div className="d-flex justify-content-center">
          <PagnationComponent
            currentPage={currentPage}
            setCurrentPage={setcurrentPage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
          />
      </div>
    </div>
  );
};

export default BranchesDataTable;
